module.exports = __webpack_public_path__ + "img/010_canadarm_thumb.eb5fea4b.jpg";